// extracted by mini-css-extract-plugin
export var borderRadius = "_f2-4";
export var large = "_f2-3";
export var logoContainer = "_f2-0";
export var nameLogo = "_f2-2";
export var small = "_f2-1";